import { MessageCircle } from 'lucide-react';
import { useT } from '@/lib/i18n';

export function ChatEmptyState() {
  const { t } = useT();
  return (
    <div className="flex flex-col items-center justify-center h-full pt-16 px-4">
      <div className="card text-center py-16 w-auto mx-auto">
        <MessageCircle className="w-16 h-16 text-dark-muted mb-4 mx-auto" />
        <h2 className="text-xl font-semibold mb-2">{t('chat.conversations.empty')}</h2>
        <p className="text-dark-muted text-center max-w-md">
          {t('chat.conversations.startNew')}
        </p>
      </div>
    </div>
  );
}

